import { render, staticRenderFns } from "./RecordTasks.vue?vue&type=template&id=b6f74e3c&"
import script from "./RecordTasks.vue?vue&type=script&lang=js&"
export * from "./RecordTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports